export class CSPUtils {
    static applyFiltersTo(schema, topFilters, optionsPotentialValues, model) {
        for (const filter of topFilters) {
            const options = optionsPotentialValues.get(filter.optionPropertyPath);
            if (!options) {
                continue;
            }
            if (!options.length) {
                throw new Error(`No available values for ${filter.optionPropertyPath}`);
            }
            const resolutionSchemaCompatibleOptions = options.filter(option => filter.match(schema, model, option));
            optionsPotentialValues.set(filter.optionPropertyPath, resolutionSchemaCompatibleOptions);
        }
    }
}
//# sourceMappingURL=CSPUtils.js.map